import { FoodCardToLogin, Login } from "./styles";
import ContentIcon from "@/shared/ContentIcon";

const FoodCardLogin = (props) => {
  const {
    onClose,
    className,
    iconClose,
    message,
    onLogin,
    buttonLabel = "Ingresar",
    imgSrc = "https://www.clarin.com/frontcdn/pages/2025/06/25/recetas-modal-1.png",
  } = props;

  return (
    <FoodCardToLogin className={className}>
      {iconClose && (
        <button type="button" onClick={onClose} className="close-button">
          <ContentIcon width="18px" height="18px" nameIcon="closeIco" />
        </button>
      )}

      <div className="food-card-login-title">
        <p>{message}</p>
      </div>

      <figure className="food-card-login-img">
        <img src={imgSrc} />
      </figure>

      <Login
        id="btn-login"
        className="button-login"
        aria-label="Boton Ingresar"
        onClick={onLogin}
      >
        <span>Ingresar</span>
        <ContentIcon width="15px" height="15px" nameIcon="avatar" fill="#000" />
      </Login>
    </FoodCardToLogin>
  );
};

export default FoodCardLogin;
